import { HelpCategory } from '../../routes/alert-submit/help-content'
import FullScreenModal from '../full-screen-modal'

import ModalContent from './modal-content'

interface IProps {
  isOpen: boolean
  onClose: () => void
  helpCategory?: HelpCategory
  supportLevel?: string | null
}

const NeedHelpModal = (props: IProps) => {
  const { isOpen, onClose, helpCategory, supportLevel } = props

  return (
    <FullScreenModal open={isOpen} onClose={onClose} title="Help & Support" showCloseIcon={true}>
      <ModalContent helpCategory={helpCategory} supportLevel={supportLevel} />
    </FullScreenModal>
  )
}

export default NeedHelpModal
